import { render, staticRenderFns } from "./AppFooterLenging.vue?vue&type=template&id=098dcf95&scoped=true&"
import script from "./AppFooterLenging.vue?vue&type=script&lang=js&"
export * from "./AppFooterLenging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098dcf95",
  null
  
)

export default component.exports